import * as React from "react";
import PropTypes from "prop-types";
import "./ContentCard.scss";
import {Button} from "semantic-ui-react";

/**
 * A custom component which renders like a Card with Header and CRUD Buttons. The buttons have an associated onClick
 * function which is passed over as a prop.
 * ContentCard has its own stylesheet where we can define specific styling depending on the use case.
 * This is to be used as a wrapper component and the content that needs to go inside the Card is passed in as the
 * child element.
 */

export default class ContentCard extends React.Component {

    static propTypes = {
        headerContent: PropTypes.string,
        hasCRUDButtons: PropTypes.bool,
        hasAddButton: PropTypes.bool,
        hasEditButton: PropTypes.bool,
        hasCloneButton: PropTypes.bool,
        hasDeleteButton: PropTypes.bool,
        onClickAdd: PropTypes.func,
        onClickEdit: PropTypes.func,
        onClickClone: PropTypes.func,
        onClickDelete: PropTypes.func,
    }

    get crudButtons() {
        const {
            hasAddButton, hasEditButton, hasCloneButton, hasDeleteButton,
            onClickAdd, onClickEdit, onClickClone, onClickDelete,
        } = this.props;

        return (
            <div className={"crud-button-group"}>
                {hasAddButton === false
                    ? null
                    : <Button icon={"add"} onClick={onClickAdd} />
                }
                {hasEditButton === false
                    ? null
                    : <Button icon={"edit outline"} onClick={onClickEdit} />
                }
                {hasCloneButton === false
                    ? null
                    : <Button icon={"copy outline"} onClick={onClickClone} />
                }
                {hasDeleteButton === false
                    ? null
                    : <Button icon={"trash alternate outline"} onClick={onClickDelete} />
                }
            </div>
        )
    }

    render() {
        const { headerContent, hasCRUDButtons, children } = this.props;

        return(
            <div className="content-card">
                <div className="content-card-header">
                    <div>{headerContent}</div>
                    {hasCRUDButtons
                        ? this.crudButtons
                        : null}
                </div>
                <div className="content-card-inner">
                    {children}
                </div>
            </div>
        )
    }
}
